import React from 'react'
import { useNode } from '@craftjs/core'

const ContentWrapper = ({ children }) => {
  const {
    connectors: { connect, drag },
  } = useNode()
  return (
    <div
      className="bg-gray-10 p-0"
      // @ts-expect-error
      ref={(ref) => connect(drag(ref!))}
      data-widgetcomponent="ContentWrapper"
    >
      {children}
    </div>
  )
}

export default ContentWrapper
